<div class="d-flex flex-row justify-content-center">
<i *ngIf="loading; else notLoading" class="fa fa-spinner fa-spin"></i>
<ng-template #notLoading>
    <div *ngIf="errorMsg" role="button" class="text-danger" [attr.title]="errorMsg">
        <i class="fa fa-exclamation-triangle text-danger"></i>
    </div>
    <button *ngIf="photoCnt" (click)="showPhotoModal()" class="w-100 btn btn-link p-0 m-0" >
        {{photoCnt||''}}
    </button>

</ng-template>
</div>
